<template>
  <component
    :is="type"
    v-bind="$props"
    class="pt border-sh-warning border-2 px-10 py-2 leading-normal"
  >
    <base-icon
      name="exclamationmark-icon"
      size="sm"
      class="absolute pin-l pin-t text-sh-warning p-2"
    />
    <base-icon
      v-if="closeable"
      name="close-icon"
      size="xs"
      class="cursor-pointer absolute pin-r pin-t p-2"
      @click.native="close"
    />
    <span class="">
      <slot />
    </span>
  </component>
</template>
<script>
export default {
  name: 'BaseError',
  props: {
    type: {
      type: String,
      default: 'div',
      validator: value => {
        return value.match(/(span|div)/);
      },
      required: false
    },
    closeable: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
};
</script>
